import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>About us</h2>

                        <p>
                          <p>
                            IDPL is the largest Central Pharma Public Sector
                            Undertaking in India with plants at Rishikesh
                            (Uttrakhand), Gurgaon (Haryana) & Hyderabad
                            (Telangana) and two wholly owned subsidiaries namely
                            IDPL (Tamil Nadu) Ltd, Chennai and Bihar Drugs &
                            Organic Chemicals Ltd (BDOCL at Muzaffarpur, Bihar.
                            In addition, IDPL has one Joint Venture namely,
                            Orrisa Drugs & Chemicals Ltd. (ODCL) Bhubaneswar
                            (Orrisa) with partnership of Odisha Government
                            Undertaking.
                          </p>
                          <p>
                            The vision of first Prime Minister of India, Late
                            Pt. Jawahar Lal Nehru regarding Indian Drug Industry
                            was that{" "}
                            <b>
                              “the drug industry must be in the public sector…..
                              I think an industry of the nature of the drug
                              industry should not be in the private sector
                              anyhow. There are for too much exploitation of the
                              public in this industry.
                            </b>{" "}
                            With the vision of the then Prime Minister of India,
                            IDPL was incorporated in April, 1961 (Company
                            Registration No. 3418 of 1961-1962 with Registrar of
                            Companies, Delhi and having its Registered and
                            Corporate Office at Gurgaon) with main objectives of
                            creating self-sufficiency in respect of essential
                            lifesaving medicines, to free the country from
                            dependence on imports and to provide medicines to
                            the millions at affordable prices and not to make
                            millions from the medicines. IDPL was basically
                            conceived and established as a part of Healthcare
                            Infrastructure and has played a pioneering
                            infra-structural role in the growth of Indian Drug
                            Industry base.
                          </p>
                          <p>
                            IDPL played a major role in the strategic National
                            Health Programmes like Family Welfare Programme &
                            Population Control (Mala-D & Mala-N) anti-malarials
                            (Chloroquine) and prevention of dehydration (ORS) by
                            providing quality medicines. During the country’s
                            calamity of outbreak of Plague in 1994, IDPL was the
                            only company which played the sheet anchor role in
                            supplying Tetracycline for the entire Nation.
                            Similarly, company had made uninterrupted supply of
                            Chloroquine to combat Malaria epidemic in different
                            parts of the country. In 2005 to combat national
                            emergency (leptospirosis) arising due to flood in
                            Maharastra, IDPL had supplied required Doxycycline
                            Caps. within no time.
                          </p>
                          <p>
                            IDPL has always supplied quality medicines and its
                            presence has played a price balancing role in the
                            competitive & business environment. World Health
                            Organisation had made its observations on IDPL as
                            follows: -
                          </p>
                          <p>
                            <i>
                              “IDPL had achieved in 10 years what others have in
                              50. IDPL products have been examined for quality
                              very carefully by the developed countries and many
                              of them want to buy from here.
                            </i>
                          </p>
                          <h2>IDPL TODAY</h2>

                          <p>
                            <b>Closure of IDPL: -</b> Union cabinet in its
                            meeting held on 28th December, 2016 conveyed by
                            Department of Pharmaceuticals, Ministry of Chemicals
                            & Fertilizers has decided to close down IDPL, its
                            subsidiaries and JV Company. In pursuance of the
                            Union Cabinet’s decision, the closure process is in
                            progress at present.{" "}
                          </p>
                        </p>

                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
